import "core-js/modules/es.array.at.js";
import "core-js/modules/es.string.at-alternative.js";
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/image/manuals.svg';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-7982dad6"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "manuals",
  id: "productManuals"
};
var _hoisted_2 = {
  class: "manuals-name"
};
var _hoisted_3 = {
  key: 0
};
var _hoisted_4 = ["onClick"];
var _hoisted_5 = {
  class: "cover"
};
var _hoisted_6 = {
  key: 1,
  src: _imports_0,
  alt: ""
};
var _hoisted_7 = {
  class: "manuals-main-left-box"
};
var _hoisted_8 = {
  class: "manuals-main-left-box-title"
};
var _hoisted_9 = {
  class: "manuals-main-left-box-info"
};
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "color": "#DADFE6"
    }
  }, "|", -1);
});
var _hoisted_11 = {
  class: "manuals-main-right"
};
var _hoisted_12 = ["onClick"];
var _hoisted_13 = {
  class: "no-more"
};
import { useMatomo } from '@shining3d/matomo';
import WordHighlighter from 'vue-word-highlighter';
import { useStore } from 'vuex';
import { $convertUTCDateToLocalDate, $getCdnUrl } from '../../../assets/common/common';
import { useLang } from '../../../hooks/lang';
import downloadFile from '../../../utils/download';
export default {
  props: {
    isSearch: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: function _default() {
        return [{
          name: ''
        }];
      }
    },
    cover: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: 'productManuals'
    },
    query: {
      type: String,
      default: ''
    },
    isDocName: {
      type: Boolean,
      default: true
    }
  },
  setup: function setup(__props) {
    var _useLang = useLang(),
      $t = _useLang.$t;
    var matomo = useMatomo();
    var getUrl = function getUrl(item) {
      if (item) {
        return $getCdnUrl({
          bucket: item === null || item === void 0 ? void 0 : item.pageBucket,
          dfsID: item === null || item === void 0 ? void 0 : item.pageDfsId
        });
      } else {
        return '';
      }
    };
    var download = function download(item) {
      var url = $getCdnUrl(item);
      downloadFile(url, item.name);
      matomo.log('click', '支持与下载|产品手册|下载手册', '下载产品手册');
    };
    var preview = function preview(item) {
      if (item.docType === 'other') {
        return;
      }
      // window.open( $getCdnUrl( item ));
      window.open($getCdnUrl(item) + '?response-content-type=application/pdf', '文件预览');
      matomo.log('click', '支持与下载|产品手册|浏览手册', '用户在线查看用户手册');
    };
    var store = useStore();
    onMounted(function () {
      store.commit('setComponentNum', 1);
    });
    return function (_ctx, _cache) {
      var _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, [_createTextVNode(_toDisplayString(_unref($t)(__props.name || '')) + " ", 1), __props.isSearch ? (_openBlock(), _createElementBlock("span", _hoisted_3, "(" + _toDisplayString(__props.list.length) + ")", 1)) : _createCommentVNode("", true)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, function (item) {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "manuals-main",
          key: item.id
        }, [_createElementVNode("div", {
          class: "manuals-main-left",
          onClick: function onClick($event) {
            return preview(item);
          }
        }, [_createElementVNode("div", _hoisted_5, [__props.cover ? (_openBlock(), _createBlock(_component_el_image, {
          key: 0,
          style: {
            "width": "100%",
            "height": "100%"
          },
          src: getUrl(item),
          fit: "scale-down"
        }, null, 8, ["src"])) : (_openBlock(), _createElementBlock("img", _hoisted_6))]), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, [_createVNode(_unref(WordHighlighter), {
          query: __props.query,
          "highlight-style": "color:#FFFFFF;background: #5587FF;"
        }, {
          default: _withCtx(function () {
            return [_createTextVNode(_toDisplayString((__props.isDocName ? item === null || item === void 0 ? void 0 : item.docName : item === null || item === void 0 ? void 0 : item.name).substring(0, item.name.lastIndexOf('.'))), 1)];
          }),
          _: 2
        }, 1032, ["query"])]), _createElementVNode("div", _hoisted_9, [_createVNode(_unref(WordHighlighter), {
          query: __props.query,
          "highlight-style": "color:#FFFFFF;background: #5587FF;"
        }, {
          default: _withCtx(function () {
            var _item$name;
            return [_createElementVNode("span", null, _toDisplayString(item === null || item === void 0 || (_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.split(".").at(-1)), 1)];
          }),
          _: 2
        }, 1032, ["query"]), _hoisted_10, _createElementVNode("span", null, _toDisplayString(_unref($convertUTCDateToLocalDate)(item.createOn, 'YYYY-MM-DD')), 1)])])], 8, _hoisted_4), _createElementVNode("div", _hoisted_11, [_createElementVNode("i", {
          class: "iconfont icon-xiazai-xian",
          onClick: _withModifiers(function ($event) {
            return download(item);
          }, ["stop"])
        }, null, 8, _hoisted_12)])])), [[_vShow, __props.list.length > 0]]);
      }), 128)), _withDirectives(_createElementVNode("div", _hoisted_13, [_createElementVNode("span", null, _toDisplayString(_unref($t)("common.noData")), 1)], 512), [[_vShow, __props.list.length === 0]])]);
    };
  }
};